// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FileResourceList_fileResourceList__O3nLY {
  list-style: none;
  padding: 0;
}

.FileResourceList_fileResourceListItem__8jA5D {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
  border: 1px solid #ccc;
  padding: 0.5rem;
}

.FileResourceList_fileResourceListItem__8jA5D a {
  text-decoration: none;
  color: #000;
}

.FileResourceList_fileResourceListItem__8jA5D a:hover {
  text-decoration: underline;
}

.FileResourceList_fileResourceListItemDetails__9gD13 {
  color: #555;
  font-size: 0.9rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/FileResourceList/FileResourceList.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB","sourcesContent":[".fileResourceList {\n  list-style: none;\n  padding: 0;\n}\n\n.fileResourceListItem {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 1rem;\n  border: 1px solid #ccc;\n  padding: 0.5rem;\n}\n\n.fileResourceListItem a {\n  text-decoration: none;\n  color: #000;\n}\n\n.fileResourceListItem a:hover {\n  text-decoration: underline;\n}\n\n.fileResourceListItemDetails {\n  color: #555;\n  font-size: 0.9rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fileResourceList": `FileResourceList_fileResourceList__O3nLY`,
	"fileResourceListItem": `FileResourceList_fileResourceListItem__8jA5D`,
	"fileResourceListItemDetails": `FileResourceList_fileResourceListItemDetails__9gD13`
};
export default ___CSS_LOADER_EXPORT___;
